/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * kSPItemUpdateObj - SPItemUpdateObj, the field name/value pair for list item updates.
 * Leaf module (2026-10-22): moved out of kSPRestCore.ts so kSPRestCoreOData can build it without
 * importing its parent at runtime. kSPRestCore.ts re-exports it, so importers are unchanged.
 */

export class SPItemUpdateObj {
    public FieldName: string = "";
    public FieldValue: any = "";
}
